import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const pricingTypeApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.optional(v.string()),
  id: v.number(),
  lookupCodeType: v.string(),
});

export const pricingTypeSchema = v.object({
  ...pricingTypeApiSchema.entries,
  ...optionSchema.entries,
});

export const pricingTypesApiSchema = paginatedSchema(pricingTypeApiSchema);

export type PricingTypeApi = v.InferOutput<typeof pricingTypeApiSchema>;
export type PricingTypesApi = v.InferOutput<typeof pricingTypesApiSchema>;

export type PricingTypeFilters = Filters<PricingTypeApi>;

export type PricingTypeFiltersUpdateApi = FiltersUpdateApi<PricingTypeApi>;

export type PricingType = Prettify<Option<v.InferOutput<typeof pricingTypeSchema>>>;

export type PricingTypes = Entities<PricingType>;
